import * as Yup from 'yup';

export const AdminUserFormValidationSchema = Yup.object({
  name: Yup.string().trim().required('Name is required'),
  email: Yup.string()
    .trim()
    .email('Invalid email format')
    .required('Email is required'),
  phoneNumber: Yup.string()
    .matches(/^\d{10}$/, 'Phone number must be 10 digits')
    .required('Phone number is required'),
  status: Yup.string().trim().required('Status is required'),
  userType: Yup.string().trim().required('User type is required'),
});
